module.exports = __webpack_public_path__ + "img/upper-egypt.5ab769e0.jpeg";